import { render } from "./WallCampaign.vue?vue&type=template&id=5f7c6ead"
import script from "./WallCampaign.vue?vue&type=script&lang=js"
export * from "./WallCampaign.vue?vue&type=script&lang=js"
script.render = render

export default script